var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivecampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4174B4;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3_",
    x: 67.5,
    y: 67.5,
    className: "st0",
    width: 365,
    height: 365
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st1",
    d: "M327.2,264.5c5.6-3.9,7.2-9,7.2-13.8c0-4.9,0,4.7,0-2.2c0-5.1-2.8-9-7.2-12.2 c-3.7-2.7-139.2-96.9-139.2-96.9s0,12.2,0,20c0,7,3.8,9.3,8.5,12.6c6.8,4.8,112.6,78.3,112.6,78.3s-107.2,74.1-113.6,78.3 c-6.7,4.4-7.5,7.4-7.5,13.3c0,5.9,0,18.7,0,18.7S321.2,268.7,327.2,264.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st1",
    d: "M188,205.8c0,5.4,0,13.8,0,13.8s41.8,29.2,49.9,34.6c6.9,4.6,12.7,4.2,19.8-1 c4.4-3.2,8.5-6.1,8.5-6.1s-60.9-42.3-67.4-46.5C193.7,197.2,188,199.6,188,205.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivecampaign);
export default __webpack_public_path__ + "static/media/activecampaign.33c8ea50a2af7cf72c4591296c7291e0.svg";
export { ForwardRef as ReactComponent };